<template>
  <div id="app">
    <czheader
      v-if="$store.state.showHeader"
      :pageName="pageName"
      :backIndex="false"
    ></czheader>
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <czfooter v-if="$store.state.showBottom"></czfooter>
  </div>
</template>

<script>
import czheader from "./components/commonhead";
import czfooter from "./components/commonfooter";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      pageName: "车镇车源",
      scrollShow: false, //是否显示返回顶部
      isRouterAlive: true,
    };
  },
  components: {
    czheader,
    czfooter,
  },
  methods: {
    // 接受子组件返回的tit
    gotSontit: function (msg) {
      this.pageName = msg;
    },
    // 重新加载页面
    reload: function () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/App.vue